module.exports = __webpack_public_path__ + "static/media/blog-6.a479cf1c.jpg";